var React = require('react');

function Watch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 10L8 13","stroke":"currentColor","key":0}),React.createElement("rect",{"x":"2.5","y":"2.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","key":1}),React.createElement("line",{"x1":"4","y1":"13.5","x2":"12","y2":"13.5","stroke":"currentColor","key":2})]);
}

Watch.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Watch;

Watch.default = Watch;
